import React from "react";
import { ArrowRight } from "lucide-react";
import { TILES } from "../../mock/mock";

const Tile = ({ tile }) => {
  if (tile.kind === "photo") {
    return (
      <a href="#" className="group relative block overflow-hidden aspect-[4/5] bg-[#c7bca0]">
        <img
          src={tile.image}
          alt={tile.alt || ""}
          className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#41232E]/25 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </a>
    );
  }
  return (
    <a
      href="#"
      className="group relative flex flex-col justify-between aspect-[4/5] p-6 md:p-8 overflow-hidden"
      style={{ backgroundColor: tile.bg, color: tile.fg }}
    >
      <div className="font-serif-display leading-[1.02] tracking-[-0.01em] text-[1.9rem] sm:text-[2.1rem] md:text-[2.3rem] lg:text-[2.6rem]">
        {tile.text}{" "}
        <em className="italic font-light">{tile.emphasis}</em>
        {tile.tail ? <> {tile.tail}</> : null}
      </div>
      <div className="flex items-end justify-between">
        <span
          className="inline-flex items-center justify-center transition-transform duration-500 group-hover:translate-x-1"
          aria-hidden="true"
        >
          <ArrowRight size={22} strokeWidth={1.5} />
        </span>
      </div>
    </a>
  );
};

const Ideas = () => {
  return (
    <section id="ideas" className="py-20 md:py-28 bg-[#FFFDF6]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-12 md:mb-14">
        <div className="uppercase tracking-[0.28em] text-[0.72rem] text-[#605F26] mb-6 om-fade-up">
          The questions
        </div>
        <h2 className="font-serif-display text-[#41232E] text-4xl md:text-6xl leading-[1.02] tracking-[-0.02em] max-w-3xl om-fade-up">
          The quiet questions we&rsquo;re all{" "}
          <em className="italic text-[#605F26]">asking.</em>
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-0 om-fade-up">
        {TILES.map((tile, i) => (
          <Tile key={i} tile={tile} />
        ))}
      </div>
    </section>
  );
};

export default Ideas;
